import React, { useState, useEffect } from "react";

const Reloj = () => {
  const [segundosTotales, setSegundosTotales] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setSegundosTotales((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(intervalo);
  }, []);

  const minutos = Math.floor(segundosTotales / 60);
  const segundos = segundosTotales % 60;

  return (
    <div
      id="reloj-duracion"
      className="text-xl font-bold mt-2"
    >
      {String(minutos).padStart(2, "0")}:{String(segundos).padStart(2, "0")}
    </div>
  );
};

export default Reloj;
